exports = module.exports = require("../node_modules/_css-loader@0.28.4@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App___3Ge-C {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo___S1Lue {\r\n  -webkit-animation: App-logo-spin___2zbnz infinite 20s linear;\r\n          animation: App-logo-spin___2zbnz infinite 20s linear;\r\n  height: 80px;\r\n}\r\n\r\n.App-header___1mzDF {\r\n  background-color: #222;\r\n  height: 150px;\r\n  padding: 20px;\r\n  color: white;\r\n}\r\n\r\n.App-intro___2BdAl {\r\n  font-size: large;\r\n}\r\n\r\n@-webkit-keyframes App-logo-spin___2zbnz {\r\n  from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\r\n  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes App-logo-spin___2zbnz {\r\n  from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\r\n  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\r\n}\r\n", ""]);

// exports
exports.locals = {
	"App": "App___3Ge-C",
	"App-logo": "App-logo___S1Lue",
	"App-logo-spin": "App-logo-spin___2zbnz",
	"App-header": "App-header___1mzDF",
	"App-intro": "App-intro___2BdAl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.4@css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/_postcss-loader@2.0.6@postcss-loader/lib?{"ident":"postcss"}!./src/App.css
// module id = 381
// module chunks = 0